<template>
  <section>
    <!-- "header" content -->
    <header-content-services
      :topSpace="'padding: 60px 0px;'"
    />

    <!-- content revolution -->
    <revolution />

    <!-- services content 1 -->
    <services-content-fourth/>

    <!-- services content 2 -->
    <services-content-fifth/>

    <!-- services content 3 -->
    <services-content-sixth/>
  </section>
</template>

<script>
// services
import HeaderContentServices from '@/components/services/HeaderContentServices'
import Revolution from '@/components/services/Revolution'
import ServicesContentFourth from '@/components/services/ServicesContentFourth'
import ServicesContentFifth from '@/components/services/ServicesContentFifth'
import ServicesContentSixth from '@/components/services/ServicesContentSixth'

export default {
  props: {
    busTopSpace: {
      type: String, 
      required: true
    }
  },
  components: {
    HeaderContentServices,
    'services-content-fourth': ServicesContentFourth,
    'services-content-fifth': ServicesContentFifth,
    'services-content-sixth': ServicesContentSixth,
    Revolution
  }
}
</script>
